(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('specific-question', {
            parent: 'entity',
            url: '/specific-question?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.specificQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specific-question/specific-questions.html',
                    controller: 'SpecificQuestionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specificQuestion');
                    $translatePartialLoader.addPart('specificQuestionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('specific-question-detail', {
            parent: 'specific-question',
            url: '/specific-question/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.specificQuestion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specific-question/specific-question-detail.html',
                    controller: 'SpecificQuestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specificQuestion');
                    $translatePartialLoader.addPart('specificQuestionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SpecificQuestion', function($stateParams, SpecificQuestion) {
                    return SpecificQuestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'specific-question',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('specific-question-detail.edit', {
            parent: 'specific-question-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-dialog.html',
                    controller: 'SpecificQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SpecificQuestion', function(SpecificQuestion) {
                            return SpecificQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specific-question.new', {
            parent: 'specific-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-dialog.html',
                    controller: 'SpecificQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sender: null,
                                content: null,
                                creationtime: null,
                                answertime: null,
                                specificquestionstate: null,
                                name: null,
                                subject: null,
                                senderSecondaryEmail: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('specific-question', null, { reload: 'specific-question' });
                }, function() {
                    $state.go('specific-question');
                });
            }]
        })
        .state('specific-question.edit', {
            parent: 'specific-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-dialog.html',
                    controller: 'SpecificQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SpecificQuestion', function(SpecificQuestion) {
                            return SpecificQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specific-question', null, { reload: 'specific-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specific-question.delete', {
            parent: 'specific-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-delete-dialog.html',
                    controller: 'SpecificQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SpecificQuestion', function(SpecificQuestion) {
                            return SpecificQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specific-question', null, { reload: 'specific-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
